import { getMCPMonitorDistribution } from "@/api/endpoints/searches";
import { Source } from "@/constants";
import { SearchFilterV4WithDates } from "@/types/SearchFilter";
import {
  Widget,
  WidgetContent,
  WidgetHeader,
  WidgetProps,
  WidgetTitle,
} from "@components/ui/widget";
import { Trans } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";
import ChannelTypeShare from "@/components/widgets/partials/ChannelTypeShare";
import { getMCPMonitorFiltersFromSearchFilterV4 } from "@components/widgets/utils";

export default function ChannelTypesByReachWidget({
  searchUuid,
  filters,
  ...rest
}: {
  filters: SearchFilterV4WithDates;
  searchUuid: Uuid;
} & WidgetProps) {
  // Server state
  const {
    data: channelTypeDistribution,
    isLoading: isChannelTypeDistributionLoading,
  } = useQuery({
    queryKey: [
      searchUuid,
      "insights-reach",
      "channel-type-distribution",
      filters,
    ],
    queryFn: () =>
      getMCPMonitorDistribution(searchUuid, {
        ...getMCPMonitorFiltersFromSearchFilterV4(filters),
        metric: "reach",
      }),
  });

  const shares = channelTypeDistribution?.ok
    ? Object.entries(channelTypeDistribution.data.shares)
        .filter(([, value]) => !!value)
        .toSorted((a, b) => {
          return b[1] - a[1];
        })
    : undefined;

  // Helpers
  const isLoading = isChannelTypeDistributionLoading;

  return (
    <Widget {...rest}>
      <WidgetHeader isLoading={isLoading} skeletonClassName="h-6">
        <WidgetTitle>
          <Trans>Räckvidd per medietyp</Trans>
        </WidgetTitle>
      </WidgetHeader>
      <WidgetContent
        className="divide-y gap-0 overflow-y-auto"
        isLoading={isLoading}
      >
        {shares
          ? shares.map(([source, share]) => (
              <ChannelTypeShare
                key={source}
                source={source as Source}
                share={share}
              />
            ))
          : null}
      </WidgetContent>
    </Widget>
  );
}
